var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTel = function SvgTel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13 9.984v1.807a1.203 1.203 0 0 1-1.316 1.204 11.955 11.955 0 0 1-5.207-1.848 11.754 11.754 0 0 1-3.62-3.613 11.902 11.902 0 0 1-1.852-5.221A1.203 1.203 0 0 1 2.205 1h1.81a1.206 1.206 0 0 1 1.207 1.036 7.72 7.72 0 0 0 .423 1.692c.165.44.06.936-.272 1.27l-.766.765a9.644 9.644 0 0 0 3.62 3.613l.766-.765c.335-.33.832-.436 1.273-.27a7.76 7.76 0 0 0 1.696.42A1.205 1.205 0 0 1 13 9.985Z",
    stroke: "var(--native-icon-fill)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgTel;